module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone.0033a7d1.svg";